(function () {
  var shippingAddressParams = {};

  function buildCheckoutShippingParam(fieldName) {
    return 'checkout[shipping_address][' + fieldName + ']';
  }

  function rebuildCartFormAction() {
    var cartForm = document.querySelector('.js-cart-form');
    if (!cartForm) return;

    if (!cartForm.dataset.baseAction) {
      cartForm.dataset.baseAction = cartForm.getAttribute('action').split('?')[0];
    }

    var queryPairs = Object.keys(shippingAddressParams)
      .filter(function (paramName) { return shippingAddressParams[paramName]; })
      .map(function (paramName) {
        return paramName + '=' + encodeURIComponent(shippingAddressParams[paramName]);
      });

    cartForm.action = queryPairs.length
      ? cartForm.dataset.baseAction + '?' + queryPairs.join('&')
      : cartForm.dataset.baseAction;
  }

  function onAddressPrefillChange(event) {
    var addressInput = event.target.closest('[js-address-prefill]');
    if (!addressInput) return;

    var fieldName = addressInput.dataset.target;
    shippingAddressParams[buildCheckoutShippingParam(fieldName)] = addressInput.value.trim();
    rebuildCartFormAction();
  }

  document.addEventListener('input', onAddressPrefillChange);
  document.addEventListener('change', onAddressPrefillChange);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[js-address-prefill]').forEach(function (addressInput) {
      if (addressInput.value) {
        var fieldName = addressInput.dataset.target;
        shippingAddressParams[buildCheckoutShippingParam(fieldName)] = addressInput.value.trim();
      }
    });
    rebuildCartFormAction();
  });
})();
